export const MOCK_CARS = [
  {
    id: 1,
    name: 'The Executive 4-Seater',
    description: 'Spacious plush leather seating and a built-in refrigerated cooler for ultimate comfort wherever you go in San Pedro.',
    images: [
      'https://lh3.googleusercontent.com/aida-public/AB6AXuAQVadqyOncZj1Qi5JR5kYgob-KOEi_2otJ4ILIHVCo9soB95B06lsMgwWlWhmpbCPd0DweeOibioIwKON5KnZC7f7upCzz2D8ucW52khP7fzMRZZlWPDKRlv5pjIhJ5msnqq9T5ZFgHF8VWyw5zPZoVRJc_13ZxdidkjbNAw-P6yBsS-IT6toKnX2KcqiLP3eQpmg4onQt8GbAaK5F8xaWLwqk20UBPPo4g4uk9v8AzhOi12suPNnnM7OeWw50O0knp9qKpfFMyCf6',
    ],
    video: null,
    badge: 'Premium',
    badge_icon: 'bolt',
    tags: [],
    seat: '4 Seats',
    created_at: '2024-01-01',
  },
  {
    id: 2,
    name: 'The Pro Sport 2-Seater',
    description: 'Enhanced suspension for smooth navigation across any terrain. Compact, agile, and perfect for the competitive golfer.',
    images: [
      'https://lh3.googleusercontent.com/aida-public/AB6AXuAcZ2COSTSw5hJei5FAfyjl_wnv7LyE6ZXoxvOaQ511IwtLi3vUqlytKsZVbS60WEZBquCDd9YzEQ2anqDv9UylgTzhqeQuOPBII0g-By_reuq2rYvVgs4HqiPDhocuLvj85CeszKAwLqmFO15rujOjoyI_r8regL8orAeCUFyJYaxSB0p5qs6EQOj8p-dHAcA2TxJyZl-6dTKUsKysuWAUK0wYJoDA6WMBhD4hnHLuJ5BHgEi8_Ur5aBdPs3SsZTj_PY2lN26AsZmR',
    ],
    video: null,
    badge: 'Performance',
    badge_icon: 'bolt',
    tags: [],
    seat: '2 Seats',
    created_at: '2024-01-05',
  },
  {
    id: 3,
    name: 'The Heritage Classic',
    description: 'Timeless aesthetic meets modern engineering. Hand-stitched upholstery and vintage-inspired chrome accents.',
    images: [
      'https://lh3.googleusercontent.com/aida-public/AB6AXuC0eRPm7l1DOVyobRv6Bl_bRv-sPGNXWw8e1SoTjQrRfvB1h5lxFKpIQITbaqnU2TWHYLa9Tq_SjYKtw-UlkjYFjY-k65VY1s1Ux8kdkH4uc5SwCzQwJjLW0qL3XdzTDmWgBiDfN2aaTEbyPfTYWnGTMdNjRkC4Ux7DKcUB1QetuZ_ez9gJICOLw_RDdlSHwBVodC6b0CIhcvaD8ihv6BK5138NZsjuvRjHyG0UMaT7nolB0r3Y1oV0oCvw6hC_DvsrNw0md4YK2YWr',
    ],
    video: null,
    badge: 'Classic Series',
    badge_icon: 'bolt',
    tags: [],
    seat: '4 Seats',
    created_at: '2024-01-10',
  },
  {
    id: 4,
    name: 'The Ranger Utility',
    description: 'Built for heavy-duty resort operations. Reinforced chassis and expanded cargo capacity for professional use.',
    images: [
      'https://lh3.googleusercontent.com/aida-public/AB6AXuAsKqFzqfKx9cI6sxplI8Hi_Icj6_wAzjsZHQo9GoFqmIDozvuodWVMo2zcZQBYe4lQWN4X26l0uZPmEXXu7Wy6HjDI8Q_W4UzkK5nUYftMue-1dLWgPoUAB4pgsoSyNtvKtWMH4XzRe1I81LDeNqmRzG8yyCsvhDdNY_PHcDtwjtgwM7kJIgk1ZHPAg87N_CWHYku7G2mXBLXm57whmhFmYJ-f5wTwc13J60JX4xJMLOJUXJuIU9ut2WZVdWdOfWu36D9LBb3QOjFR',
    ],
    video: null,
    badge: 'All-Terrain',
    badge_icon: 'bolt',
    tags: [],
    seat: '2 Seats',
    created_at: '2024-01-15',
  },
  {
    id: 5,
    name: 'The Vista 6-Seater',
    description: 'The ultimate family cruiser. Spacious seating with extra legroom and a wrap-around security railing.',
    images: [
      'https://lh3.googleusercontent.com/aida-public/AB6AXuDxfvAOqtn0Mbg9SaW4r4TVPXsZLh6fcW7bMq3ZXxZhJ73STeYV_RhAvuhVBzTM2CuN6ZR68OQl2V7OMUPuJb0pj49NAZMLpH_fhWjW0mE-ZhsrP8bu-c61H6ItJMFMk6lJt08hnZaViIq0XeD8Vt0g5bwKkWGQKHNnIgOusIKlPNYwUbGgWWZatkRUxoTO74PWNtbMicA8gNPHS2J7EPbq9K_hK6sK6KBwusCaJ6Z9W4PkojUXLb5aYrrRloa8djKk8zVFVkp2qPp4',
    ],
    video: null,
    badge: 'Group Transport',
    badge_icon: 'bolt',
    tags: [],
    seat: '6 Seats',
    created_at: '2024-01-20',
  },
  {
    id: 6,
    name: 'The Apex Carbon',
    description: 'Lightweight carbon fiber body with racing-tuned motor. Zero to full speed in record time with custom styling.',
    images: [
      'https://lh3.googleusercontent.com/aida-public/AB6AXuBs6KvsXyjmnBFAkotAaHq7fhX4gHR9XljkROvR35xIq67sQcdoVrcwqzUXj8m2E0T-jo79CIxb-BecWTiAqN8vSAAbXp8r9lRB_A4X65L87PO3nCIMhTXwt74XI1FUTvaLlNx1efKjOZO_dvV0EJd9K_cphoDwe9YaiAyLA44UKyxn-i4HujJ-SPd7uli2JOo_2ygD8wXx4uDw3kTrBwrkHDqG71yvDYyvpd_oVFQhZSvejML7Op7c4u4VA1BhDsMcyQv_rqNcq0Ef',
    ],
    video: null,
    badge: 'Limited Edition',
    badge_icon: 'bolt',
    tags: [],
    seat: '2 Seats',
    created_at: '2024-01-25',
  },
];

export const MOCK_REVIEWS = [
  { id: 1, name: 'Sarah M.', rating: 5, comment: 'Absolutely incredible experience! The cars are immaculate and the service was top-notch. Will definitely book again.', created_at: '2024-03-15' },
  { id: 2, name: 'James K.', rating: 5, comment: 'The Executive 4-Seater was perfect for our family round. Quiet, smooth, and luxurious. Highly recommend!', created_at: '2024-03-10' },
  { id: 3, name: 'Guest', rating: 4, comment: 'Great fleet selection and easy booking process. The cart was pristine and ready to go. Only minor issue was pickup timing.', created_at: '2024-03-05' },
  { id: 4, name: 'Thomas R.', rating: 5, comment: 'Best golf experience we\'ve ever had. The Heritage Classic was a showstopper on the course!', created_at: '2024-02-28' },
];

export const MOCK_ADDRESSES = [
  { id: 1, name: 'North Fairway Entrance', image: null },
  { id: 2, name: 'Club House Main Gate', image: null },
  { id: 3, name: 'South Resort Lobby', image: null },
  { id: 4, name: 'Marina Bay Drop-off', image: null },
];

export const MOCK_SEATS = [
  { id: 1, value: '2 Seats' },
  { id: 2, value: '4 Seats' },
  { id: 3, value: '6 Seats' },
];
